<template>
  <div style="display:flex; flex-direction:column;align-items: center">
    <el-table
      v-loading="loading"
      :border="hideBorder ? false : true"
      :data="dataList"
      :stripe="hideStripe ? false : true"
      :row-key="rowKey"
      :tree-props="treeProps"
      @selection-change="setSelectRows"
    >
      <template v-for="(column, index) in tableColumns">
        <slot v-if="column.type == 'itemSlot'"   :name="column.key" />
        <el-table-column
          v-else-if="column.type == 'selection'"
          :key="'column' + index"
          :reserve-selection="reserveSelection"
          type="selection"
          :align="column.align ? column.align : 'center'"
          :width="column.width"
          show-overflow-tooltip
        />
        <el-table-column
          v-else
          :key="'column' + index"
          :type="column.type"
          :align="column.align ? column.align : 'center'"
          :label="column.title"
          :fixed="column.fixed"
          :prop="column.key"
          :width="column.width"
          show-overflow-tooltip
        >
          <template #default="{ row }" v-if="column.type == 'slot'">
            <slot :name="column.key" :row="row"></slot>
          </template>

          <template #default="{ row }" v-else>
            <span>{{row[column.key]}}</span>
          </template>

        </el-table-column>
      </template>

      <template #empty>
        <el-empty class="vab-data-empty" description="暂无数据" />
      </template>
    </el-table>
    <el-pagination
      style="margin-top: 20px"
      v-if="isPage"
      background
      :layout="layout"
      :current-page="curIndex"
      :page-size="pageSize"
      :total="totalRows"
      @current-change="onChangePage"
      @size-change="onPageSizeChange"
    />

  </div>
</template>

<script>
  export default {
    name: 'xcBaseTable',
    props: [
      'tableColumns', // 搜索回调
      'asyncFunc', // 请求方法
      'noPage', // 不分页
      'searchParams',//请求参数
      'listName',//返回列表字段名
      'rowKey',
      'reserveSelection',//是否数据更新之后保留之前选中的数据（需指定 row-key）
      'treeProps',
      'hideBorder',
      'hideStripe',
      'onSuccess',
    ],
    data() {
      return {
        layout: 'total, sizes, prev, pager, next',
        dataList: [],
        curIndex: 1, // 当前页
        pageSize: 10,//一页的数量
        totalRows: 0,//数据总条数
        loading: false,

        selectRows: '',
      }
    },
    computed: {
      isPage() {
        return this.noPage ? false : true;
      }
    },
    methods: {
      getParams(){
        let params = {}
        if(this.isPage) {
          params = {
            pageNum: this.curIndex, //页码
            pageSize: this.pageSize, //每页大小
          }
        }
        if(this.searchParams) {
          params = {
            ...params,
            ...this.searchParams
          }
        }
        return params
      },
      async fetchData(index){
        setTimeout(()=>{
          if(this.asyncFunc) {
            if(index) {
              this.curIndex = index ? index : 1
            }
            let params = this.getParams()
            this.loading = true
            this.asyncFunc(params, (data)=>{
              this.$emit('onSuccess', data)
              let detail = data.data
              this.dataList = detail[this.listName] ? detail[this.listName] : []
              if (this.curIndex > 1 && this.dataList.length == 0) {
                this.fetchData(this.curIndex - 1)
              } else {
                this.totalRows = detail.totalRows ? detail.totalRows : 0
                if(!this.totalRows) {
                  this.totalRows = detail.total ? detail.total : 0
                }
                this.loading = false
              }
            })
          }
        })
      },
      setSelectRows(val) {
        this.selectRows = val
      },
      getSelection() {
        return this.selectRows ? this.selectRows : [];
      },
      //点击页码时回调
      onChangePage(index) {
        this.curIndex = index;
        this.fetchData(this.curIndex);
      },
      //切换每页条数时的回调
      onPageSizeChange(pageSize) {
        this.pageSize = pageSize;
        this.curIndex = 1;
        this.fetchData(this.curIndex);
      },
    },
  }
</script>

<style lang="less"  scoped></style>
